// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__VyY1h","item":"styles_item__3kjfo","hiddenStyle":"styles_hiddenStyle__3rm4F"};